import React, { useState, useEffect } from 'react';
import apiService from '../api/apiService';
import './Reports.css';

const Reports: React.FC = () => {
  const [daily, setDaily] = useState<any>(null);
  const [distributorWise, setDistributorWise] = useState<any[]>([]);
  const [driverWise, setDriverWise] = useState<any[]>([]);
  const [revenue, setRevenue] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  useEffect(() => {
    const to = new Date();
    const from = new Date(to);
    from.setDate(from.getDate() - 30);
    setToDate(to.toISOString().slice(0, 10));
    setFromDate(from.toISOString().slice(0, 10));
  }, []);

  const loadDaily = async () => {
    try {
      const params = new URLSearchParams();
      if (fromDate) params.set('from_date', fromDate);
      if (toDate) params.set('to_date', toDate);
      const { data } = await apiService.get(`/admin/reports/daily?${params}`);
      setDaily(data);
    } catch (e) {
      console.error(e);
    }
  };

  const loadDistributorWise = async () => {
    try {
      const { data } = await apiService.get('/admin/reports/distributor-wise');
      setDistributorWise(data);
    } catch (e) {
      console.error(e);
    }
  };

  const loadDriverWise = async () => {
    try {
      const { data } = await apiService.get('/admin/reports/driver-wise');
      setDriverWise(data);
    } catch (e) {
      console.error(e);
    }
  };

  const loadRevenue = async () => {
    try {
      const params = new URLSearchParams();
      if (fromDate) params.set('from_date', fromDate);
      if (toDate) params.set('to_date', toDate);
      const { data } = await apiService.get(`/admin/reports/revenue?${params}`);
      setRevenue(data);
    } catch (e) {
      console.error(e);
    }
  };

  const loadAll = async () => {
    setLoading(true);
    await Promise.all([loadDaily(), loadDistributorWise(), loadDriverWise(), loadRevenue()]);
    setLoading(false);
  };

  useEffect(() => {
    if (fromDate && toDate) loadAll();
  }, [fromDate, toDate]);

  if (loading && !daily) {
    return <div className="reports-page"><div className="reports-loading">Loading reports...</div></div>;
  }

  return (
    <div className="reports-page">
      <div className="reports-hero">
        <h1>Reports &amp; analytics</h1>
        <p>View orders, revenue and performance by date range</p>
        <div className="reports-date-bar">
          <label>From <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} /></label>
          <label>To <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} /></label>
          <button type="button" className="reports-refresh-btn" onClick={loadAll}>Refresh</button>
        </div>
      </div>

      <div className="reports-kpi-row">
        {daily && (
          <>
            <div className="reports-kpi-card">
              <div className="reports-kpi-icon">📦</div>
              <div className="reports-kpi-value">{daily.orders_count ?? 0}</div>
              <div className="reports-kpi-label">Orders (period)</div>
            </div>
            <div className="reports-kpi-card reports-kpi-card--accent">
              <div className="reports-kpi-icon">₹</div>
              <div className="reports-kpi-value">{daily.revenue ?? 0}</div>
              <div className="reports-kpi-label">Revenue (period)</div>
            </div>
          </>
        )}
        {revenue && !daily && (
          <div className="reports-kpi-card reports-kpi-card--accent">
            <div className="reports-kpi-icon">₹</div>
            <div className="reports-kpi-value">{revenue.revenue ?? 0}</div>
            <div className="reports-kpi-label">Revenue</div>
          </div>
        )}
      </div>

      <section className="reports-section">
        <h2 className="reports-section-title">
          <span className="reports-section-icon">👥</span>
          Distributor-wise
        </h2>
        {distributorWise.length === 0 ? (
          <div className="reports-empty">No distributor data for this period.</div>
        ) : (
          <ul className="reports-list">
            {distributorWise.map((r: any, i: number) => (
              <li key={i} className="reports-list-item">
                <span className="reports-list-name">{r.distributor_name}</span>
                <span className="reports-list-metric">{r.orders_count} orders</span>
                <span className="reports-list-value">₹{r.revenue}</span>
              </li>
            ))}
          </ul>
        )}
      </section>

      <section className="reports-section">
        <h2 className="reports-section-title">
          <span className="reports-section-icon">🚚</span>
          Driver-wise deliveries
        </h2>
        {driverWise.length === 0 ? (
          <div className="reports-empty">No driver delivery data.</div>
        ) : (
          <ul className="reports-list">
            {driverWise.map((r: any, i: number) => (
              <li key={i} className="reports-list-item">
                <span className="reports-list-name">{r.driver_name}</span>
                <span className="reports-list-metric">{r.distributor_name}</span>
                <span className="reports-list-value">{r.deliveries} deliveries</span>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
};

export default Reports;
